import CryptoJS from 'crypto-js'
import base from '../api/baseUrl'
import { Notification ,Message } from 'element-ui'
import baseUrlDomin from '../api/domin'
//const token='12345678';  // 定义常量
var allFu = {
    // cookie
    // getAll:function(){
    //     var arr=document.cookie.split(';');
    //     var obj={};
    //     for(var i=0;i<arr.length;i++){
    //         obj[arr[i].split('=')[0]]=arr[i].split('=')[1];
    //     }
    //     return obj;
    // },
    // get:function(key){
    //     return this.getAll()[key];
    // },
    get(key) {
        if (document.cookie.length > 0) {
          var start = document.cookie.indexOf(key + "=");
          if (start !== -1) {
            start = start + key.length + 1;
            var end = document.cookie.indexOf(";", start);
            if (end === -1) end = document.cookie.length;
            return unescape(document.cookie.substring(start, end));
          }
        }
        return "";
    },  
    set:function(key,value,time){
        // var date=new Date().getTime()+time*1000;
        // document.cookie= subCookies + ';expires='+new Date(date).toUTCString() + ';Domain=.' + baseUrlDomin;
        // console.log(document.cookie,'---- document.cookie ----',subCookies)

        var date=new Date().getTime()+time*1000;
        document.cookie=key+'='+value+';expires='+new Date(date).toUTCString() + ';Domain=.' + baseUrlDomin;
        console.log(document.cookie,'---- document.cookie ----')
        
    },
    remove:function(key){
        var date=new Date().getTime()-1;
        document.cookie=key+'=;expires='+new Date(date).toUTCString() + ';Domain=.' + baseUrlDomin;
    },
    // 加密
    encryption:function(pas) {
        let jsonString = JSON.stringify(pas) ;
        var b = CryptoJS.enc.Base64
        var key = CryptoJS.enc.Utf8.parse('xIj5K&BwyslAwlKV') //秘钥
        var srcs = CryptoJS.enc.Utf8.parse(jsonString);
        var encrypted = CryptoJS.AES.encrypt(srcs, key, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        })
        return b.stringify(encrypted.ciphertext)
    },
    // 解密
    decrypt:function (word, keyStr) { // 解密
        var key = CryptoJS.enc.Utf8.parse(keyStr)
        var decrypt = CryptoJS.AES.decrypt(word, key, {mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7})
        let datas = CryptoJS.enc.Utf8.stringify(decrypt) ;
        // console.log(JSON.parse(datas),'----datas-----')
        return JSON.parse(datas);
    },
    // // 获取url截取
    // getSearchString:function () {
    //     let data = {};
    //     let src = window.location.href ;
    //     let dataStr = src.substring(src.indexOf("?") + 1);
    //     let dataArray = dataStr.split("&");
    //     for (let i = 0; i < dataArray.length; i++) {
    //         let param = dataArray[i].split("=");
    //         data[param[0]] = param[1];
    //     }
    //     return data ;
    // },
    // 判断正式环境，还是测试环境
    isProduct:function () {
        if(base.indexOf('cloud.hotel.xinjingtech.net') != -1){
            return true;
        }else if(base.indexOf('pre.xinjngtech.com') != -1){
            return true;
        }
        // 测试加密，上线注销
        // else if(base.indexOf('test.xinjngtech.com') != -1){
        //     return false;
        // }
        else{
            return false ;
        }
    },
    //判断电话和座机
    mobileRules:function (value) {
        const isPhone = /^([0-9]{3,4}-)?[0-9]{7,8}$/; // 0571-86295197
        const isPhone02 = /^\d{3,4}-\d{3,4}-\d{3,4}$/; // 4001-550-520
        // const isPhone02 = /^[0-9]{3,4}-[0-9]{2,3}-[0-9]{2,3}$/; // 4001-550-520
        // const isPhone02 = /^([0-9]{3,4}-)?([0-9]{3,4}-)?[0-9]{3,4}$/; // 4001-550-520
        const isMob = /^((0\d{2,3}-?\d{7,8})|(1[3465789]\d{9}))$/;
        // const phone02 = /^0\d{2,3}-?\d{7,8}$/;
        const valuePhone = value.trim();
        if (isMob.test(valuePhone)) { // 正则验证 // 校验通过
            return true ;
        } else {
            Message({
              message: '请输入正确的手机号或者座机号',
              type: 'warning'
            })
            return false
        }   
    },
    // 不能输入汉字
    ruleChina:function (value){
        if(/^[\u2E80-\u9FFF]+$/.test(value)){
            return true ;
        }else{
            return false ;
        }
    },
    // 服务电话在输入的时候只能数字
    serverIphone:function (val){
        let arr = val.split('') ;
        let newArr = [] ;
        let newStr = '' ;
        arr.map((res,index)=>{
            let rpRes = "" ;
            if(res.indexOf('-') != -1){
                rpRes = res ;
            }else{
                rpRes = res.replace(/[^0-9]/ig,"") ;
            }
            newArr.push(rpRes) ;
        })
        console.log(newArr,'--newArr---')
        if(newArr.length){
            newArr.map(data=>{
                newStr = newStr + data ;
            })
        }
        return newStr ;
    },
    // 判断是否字符串
    // isString:function (obj){
    //     return Object.prototype.toString.call(obj) === "[object String]" ? true : false;
    // },
    // // 判断是否数组
    // isArray:function (obj){
    //     return Object.prototype.toString.call(obj) === "[object Array]" ? true : false;
    // },
    // // 判断是否为数字
    // isNumber:function (obj){
    //     return Object.prototype.toString.call(obj) === "[object Number]" ? true : false;
    // }
  
  
};

export default {
    allFu
};


// WEBPACK FOOTER //
// ./src/global/global.js